/*
 * <cta-equal-buttons> matches every `.cta-banner__btn` inside it to the width
 * of the widest one. Mobile (stacked) cards are already equalized in pure
 * CSS via `grid-template-columns: max-content`; this only kicks in for the
 * desktop row layout, where CSS alone can't compare sibling widths.
 */
if (!customElements.get('cta-equal-buttons')) {
  class CtaEqualButtons extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.cta-banner__btn'));

      if (!this.buttons.length) return;

      this._equalize = this._equalize.bind(this);

      window.addEventListener('resize', this._equalize);

      this._equalize();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this._equalize);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._equalize);
    }

    _equalize() {
      // Reset first so shrinking the viewport (or a font swap) doesn't leave
      // a stale, too-wide value baked in before re-measuring.
      this.buttons.forEach((btn) => {
        btn.style.width = '';
      });

      const isDesktop = window.matchMedia('(min-width: 768px)').matches;
      if (!isDesktop) return;

      const maxWidth = Math.max(...this.buttons.map((btn) => btn.offsetWidth));
      this.buttons.forEach((btn) => {
        btn.style.width = `${maxWidth}px`;
      });
    }
  }

  customElements.define('cta-equal-buttons', CtaEqualButtons);
}
